export default {
    bindings: {
        currency: '<'
    },
    controller: 'basketController',
    template: require('../views/basket.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/basket.component.js